import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useUser } from '@src/state/user';
import { UserRegistrationShell } from '../UserRegistrationShell';
import { UHCProviderLink } from '../UHCProviderLink';
import { UHCLink } from '../UHCLink';
import { config } from '@uhg-abyss/web/tools/config';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { LagoonContext } from '@src/AppContext/LagoonContext';

const MainContainer = styled('div', {
  border: '1px solid rgb(219, 219, 219)',
  background: '$white',
  padding: '25px',
  marginBottom: '20px',
});

const BoxHeader = styled('div', {
  position: 'relative',
  marginTop: '50px',
  marginBottom: '10px',
});

const BoxHeaderText = styled('h3', {
  fontWeight: 600,
  fontSize: '24px',
  width: '100%',
  color: '$primary1',
  fontFamily: '$heading',
});

const SaveDescription = styled('p', {
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: '$primary',
});

export const CancelRegistration = () => {
  const { isAPIMarketPlaceUser } = useUser.state();
  const lagoonContext = React.useContext(LagoonContext);
  const uiMessages = lagoonContext.getTable('ui-messaging');

  const sourceSystem = isAPIMarketPlaceUser
    ? 'UnitedHealthcare API Marketplace'
    : 'UnitedHealthcare Provider Portal';

  return (
    <UserRegistrationShell showCancelLink={false}>
      <MainContainer>
        <IconBrand
          icon="checkmark"
          variant="twotone"
          style={{ marginTop: 25 }}
          size={48}
        />
        <BoxHeader>
          <BoxHeaderText>Your registration has been cancelled.</BoxHeaderText>
        </BoxHeader>
        <SaveDescription>
          You may come back anytime to register for the {sourceSystem}.
        </SaveDescription>
      </MainContainer>
      {isAPIMarketPlaceUser ? (
        <UHCLink
          label="Return to API Marketplace"
          url={
            uiMessages.getRow('API_MARKETPLACE_WELCOME_URL')?.message ||
            config('API_MARKETPLACE_WELCOME_URL')
          }
          sameTab
        />
      ) : (
        <UHCProviderLink />
      )}
    </UserRegistrationShell>
  );
};
